import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './SaveToAlbumModal.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SaveToAlbumModal = ({ imageData, sessionToken, onClose, onSuccess }) => {
  const [albums, setAlbums] = useState([]);
  const [selectedAlbumId, setSelectedAlbumId] = useState('');
  const [newAlbumName, setNewAlbumName] = useState('');
  const [mode, setMode] = useState('existing'); // 'existing' or 'new'
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadAlbums();
  }, []);

  const loadAlbums = async () => {
    try {
      const response = await axios.get(`${API}/albums`, {
        headers: { Authorization: `Bearer ${sessionToken}` }
      });
      
      if (response.data.success) {
        setAlbums(response.data.albums);
        if (response.data.albums.length > 0) {
          setSelectedAlbumId(response.data.albums[0].id);
        }
      }
    } catch (error) {
      console.error('Error loading albums:', error);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const payload = {
        image_data: imageData,
        album_id: mode === 'existing' ? selectedAlbumId : null,
        album_name: mode === 'new' ? newAlbumName : null
      };
      
      const response = await axios.post(
        `${API}/tryon/save-to-album`,
        payload,
        { headers: { Authorization: `Bearer ${sessionToken}` } }
      );
      
      if (response.data.success) {
        alert('✅ ' + response.data.message);
        onSuccess();
        onClose();
      }
    } catch (error) {
      console.error('Error saving to album:', error);
      alert('❌ Failed to save: ' + (error.response?.data?.detail || error.message));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="save-modal-overlay" onClick={onClose}>
      <div className="save-modal" onClick={(e) => e.stopPropagation()}>
        <div className="save-modal-header">
          <h2>💾 Save to Album</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="save-modal-content">
          <div className="mode-selector">
            <button
              className={`mode-btn ${mode === 'existing' ? 'active' : ''}`}
              onClick={() => setMode('existing')}
            >
              Existing Album
            </button>
            <button
              className={`mode-btn ${mode === 'new' ? 'active' : ''}`}
              onClick={() => setMode('new')}
            >
              Create New Album
            </button>
          </div>

          {mode === 'existing' ? (
            <div className="form-group">
              <label>Select Album:</label>
              {albums.length === 0 ? (
                <p className="no-albums-message">No albums yet. Create a new one!</p>
              ) : (
                <select
                  value={selectedAlbumId}
                  onChange={(e) => setSelectedAlbumId(e.target.value)}
                >
                  {albums.map(album => (
                    <option key={album.id} value={album.id}>
                      {album.name} ({album.photo_count || 0} photos)
                    </option>
                  ))}
                </select>
              )}
            </div>
          ) : (
            <div className="form-group">
              <label>New Album Name:</label>
              <input
                type="text"
                value={newAlbumName}
                onChange={(e) => setNewAlbumName(e.target.value)}
                placeholder="e.g., My Favorite Try-Ons"
                autoFocus
              />
            </div>
          )}

          <div className="save-modal-actions">
            <button className="btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button 
              className="btn-primary" 
              onClick={handleSave}
              disabled={saving || (mode === 'existing' && !selectedAlbumId) || (mode === 'new' && !newAlbumName.trim())}
            >
              {saving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveToAlbumModal;